import { Link } from "react-router-dom";
import type { LegalBlock, LegalDoc } from "../content/legal";
import { contact } from "../content/site";
import { usePageTitle } from "./usePageTitle";

function Block({ block }: { block: LegalBlock }) {
  if (typeof block === "string") return <p>{block}</p>;
  return (
    <ul>
      {block.list.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

export default function LegalPage({ doc, other }: { doc: LegalDoc; other: { to: string; label: string } }) {
  usePageTitle(doc.title);
  return (
    <>
      <section className="page-head">
        <div className="wrap narrow center">
          <h1 className="display">{doc.title}</h1>
          <p className="label">Last updated {doc.updated}</p>
        </div>
      </section>

      <section className="band">
        <article className="wrap narrow legal">
          {doc.intro.map((b, i) => (
            <Block key={i} block={b} />
          ))}
          {doc.sections.map((s) => (
            <section key={s.heading}>
              <h2 className="section-title">{s.heading}</h2>
              {s.body.map((b, i) => (
                <Block key={i} block={b} />
              ))}
            </section>
          ))}
          <section>
            <h2 className="section-title">Contact us</h2>
            <p>
              Platform 18
              <br />
              {contact.street}
              <br />
              {contact.city}
              <br />
              <a href={`mailto:${contact.email}`}>{contact.email}</a> · <a href={contact.phoneHref}>{contact.phone}</a>
            </p>
            <p>
              See also our <Link to={other.to}>{other.label}</Link>.
            </p>
          </section>
        </article>
      </section>
    </>
  );
}
